import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const MonthlyEnergies = React.lazy(() => import('./index'));
const MeTable = React.lazy(() => import('./meTable'));
const MonthlyEnergy = React.lazy(() => import('./monthlyEnergy'));
const MpDetail = React.lazy(() => import('./meDetail'));
const AddNewMonthlyEnergy = React.lazy(() => import('./addNewMonthlyEnergy'));
const EditMonthlyEnergy = React.lazy(() => import('./editMonthlyEnergy'));

export const useMonthlyEnergyRoutes = () => {
    return (
        <React.Fragment>
            <Route path="monthlyEnergy" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyEnergies isCumulative={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MeTable isCumulative={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyEnergy isCumulative={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyEnergy isCumulative={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyEnergy /></Suspense> } />
                </Route>
            </Route>
            <Route path="cumulativeMonthlyEnergy" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyEnergies isCumulative={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MeTable isCumulative={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewMonthlyEnergy isCumulative={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><MonthlyEnergy isCumulative={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><MpDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditMonthlyEnergy /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}